import { sessionStore, updateSearchParams, clearSearchParam } from "../stores/session";
import { get } from "svelte/store";

const getURLSearchParams = () => new URLSearchParams(document.location.search);

export const getAllSearchParams = () => {
  const result: Record<string, string> = {};

  getURLSearchParams().forEach((value, key) => result[key] = value);

  return { ...get(sessionStore).searchParams, ...result };
};

export const hasSearchParams = () => getURLSearchParams().size > 0;
export const saveSearchParams = () => updateSearchParams(getAllSearchParams());
export const getSearchParam = (param: string): string | undefined => getAllSearchParams()[param];

export const removeSearchParam = (param: string) => {
  clearSearchParam(param);
  window.history.replaceState(null, "", document.location.pathname);
};
